import { SegmentedControl } from "./SegmentedControl";

interface CardStyleControlProps {
  value: string;
  onChange: (value: string) => void;
}

const OPTIONS = [
  { label: "Elevated", value: "elevated" },
  { label: "Flat", value: "flat" },
  { label: "Outlined", value: "outlined" },
];

/**
 * Three-segment toggle for card style: Elevated / Flat / Outlined.
 */
export function CardStyleControl({ value, onChange }: CardStyleControlProps) {
  return (
    <SegmentedControl
      label="Card style"
      options={OPTIONS}
      value={value}
      onChange={onChange}
    />
  );
}
